import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_PARDOT } from './constants';
import { verifyPardot } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import localStorageTemplates from 'common/local-storage-templates';

export function* savePardotCode({ payload, metadata }) {
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/integration/pardot',
      config: {
        data: {
          ...payload,
        },
      },
    });
    yield put(verifyPardot.success());
    triggerNotification({
      title: 'Pardot integrated successfully!',
      type: NOTIFICATION.TYPE.SUCCESS,
    });
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifyPardot.error(errorMessage));
  }
}

export default function* pardotVerify() {
  yield takeLatest(VERIFY_PARDOT.START, savePardotCode);
}
